var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingLine = function SvgBuildingLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B7B7B",
    d: "M16.75 15.25h1.5v1.5H1.75v-1.5h1.5V4A.75.75 0 0 1 4 3.25h7.5a.75.75 0 0 1 .75.75v11.25h3v-6h-1.5v-1.5H16a.75.75 0 0 1 .75.75zm-12-10.5v10.5h6V4.75zm1.5 4.5h3v1.5h-3zm0-3h3v1.5h-3z"
  })));
};
export default SvgBuildingLine;